function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M22.5.2h-21C.7.2 0 .8 0 1.7v18.6c0 .8.7 1.5 1.5 1.5h21c.8 0 1.5-.7 1.5-1.5V1.7c0-.9-.7-1.5-1.5-1.5zM9.3 2.5c0 .6-.5 1-1 1-.6 0-1-.5-1-1s.5-1 1-1c.5-.1 1 .4 1 1zm-2.8 0c0 .6-.5 1-1 1-.6 0-1-.5-1-1s.5-1 1-1c.5-.1 1 .4 1 1zm-2.9 0c0 .6-.5 1-1 1-.6 0-1-.5-1-1s.5-1 1-1c.5-.1 1 .4 1 1zM1.5 20.3V4.5h21v15.9h-21v-.1z",
  fill: "#231F20",
  fillRule: "evenodd"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22"
  }, props), _ref);
};

export default SvgComponent;